module.exports = val => {
    return val > 20 ? 'alarm' : 'ok';
}



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/utils/getRiskValueClass.js